import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=0574995b&scoped=true"
import script from "./MainTabBar.vue?vue&type=script&lang=js"
export * from "./MainTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574995b",
  null
  
)

export default component.exports